import { render, staticRenderFns } from "./DialogPagination.vue?vue&type=template&id=126e082e&"
import script from "./DialogPagination.vue?vue&type=script&lang=ts&"
export * from "./DialogPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports